// shopping-cart-context.js

import React, { createContext, useState } from "react";

export const CartContext = createContext({
  items: [],
});

export const CartProvider = (props) => {
  const [cartItems, setCartItems] = useState([]);

  const incrementItem = (itemId) => {
    setCartItems((prevCartItems) =>
      prevCartItems.map((item) =>
        item.id === itemId ? { ...item, quantity: item.quantity + 1 } : item
      )
    );
  };

  const decrementItem = (itemId) => {
    setCartItems((prevCartItems) =>
      prevCartItems.map((item) =>
        item.id === itemId && item.quantity > 0
          ? { ...item, quantity: item.quantity - 1 }
          : item
      )
    );
  };

  return (
    <CartContext.Provider
      value={{
        items: cartItems,
        incrementItem: incrementItem,
        decrementItem: decrementItem,
      }}
    >
      {props.children}
    </CartContext.Provider>
  );
};
